/* eslint-disable */
// Calculations on Monthly Forecast for current ratio, gross profit, and operating profit
const ratioCalculations = (key, calcs, year, isForecast = false) => {
    const ratio = {}
    const getMonthlyVals = (metricKey) => {
        const metric = calcs?.[metricKey];
        if (!metric) return {};
        return isForecast
            ? _.pickBy(metric, _.isNumber) // forecast format: flat { 1: val, 2: val }
            : _.pickBy(metric?.[year], _.isNumber); // standard format: { 2024: { 1: val, ... } }
    };
    const numerator = getMonthlyVals(key);

    let denominatorKey = null;
    if (key === 'total_current_assets') {
        denominatorKey = 'total_current_liabilities';
    }
    if (key === 'gross_profit' || key === 'operating_profit') {
        denominatorKey = 'total_revenue';
    }

    const denominator = getMonthlyVals(denominatorKey);

    Object.keys(numerator).forEach((monthStr) => {
        const month = parseInt(monthStr);
        if (_.isNumber(denominator[month])) {
            ratio[month] = numerator[month] / denominator[month];
        } else {
            ratio[month] = null;
        }
    });

    return ratio
}

// ratioCalcs for Money report
const ratioCalculationsMoney = (key, calcs, year, prevYear, numberOfMonths, isForecast = false, fallbackPrevYearData = null) => {
    const ratio = {};
    let denominator;
    let numerator = sumTrailing12MonthsValues(key, calcs, year, prevYear, isForecast, fallbackPrevYearData)
    const totalNumeratorMonths = Object.keys(numerator)
    const numberOfNumeratorMonths = numberOfMonths

    if (calcs && key === 'gross_profit' || key === 'operating_profit') {
        denominator = sumTrailing12MonthsValues('total_revenue', calcs, year, prevYear, isForecast, fallbackPrevYearData)
    } else if (key === 'total_current_assets') {
        // denominator = _.pickBy(calcs.total_current_liabilities, _.isNumber)
        denominator = sumTrailing12MonthsValues('total_current_liabilities', calcs, year, prevYear, isForecast, fallbackPrevYearData)
    }

    const totalDenominatorMonths = denominator ? Object.keys(denominator) : [];
    const numberOfDenominatorMonths = totalDenominatorMonths.length

    if (numberOfNumeratorMonths <= numberOfDenominatorMonths) {
        for (let i = 1; i <= numberOfNumeratorMonths; i++) {
            let numeratorMonth = totalNumeratorMonths[i - 1]
            let denominatorMonth = totalDenominatorMonths[i - 1]
            if (numeratorMonth === denominatorMonth) {
                ratio[i] = (numerator[i] / denominator[i])
            } else {
                ratio[i] = null
            }
        }
    }
    return ratio
}

// need to calculate EBITDA for forecast
const calculateEBITDA = (calcs, year, isForecast = false) => {
    const ebitda = {}
    const getVal = (metricKey, month) => {
        const metric = calcs?.[metricKey];
        if (!metric) return null;
        return isForecast
            ? metric?.[month]
            : metric?.[year]?.[month];
    };

    // Determine valid months from net income values
    const netIncomeVals = isForecast
        ? _.pickBy(calcs?.operating_expenses_net_income, _.isNumber)
        : _.pickBy(calcs?.operating_expenses_net_income?.[year], _.isNumber);

    const months = Object.keys(netIncomeVals).map(Number);
    months.forEach((month) => {
        const netIncome = getVal('operating_expenses_net_income', month);
        const interest = getVal('interest_and_other_expenses', month);
        const taxes = getVal('total_other_costs_taxes_- federal & state', month);
        const deprAmor = getVal('depreciation_and_amortization', month);

        if (
            _.isNumber(netIncome) &&
            _.isNumber(interest) &&
            _.isNumber(taxes) &&
            _.isNumber(deprAmor)
        ) {
            ebitda[month] = netIncome + interest + taxes + deprAmor;
        } else {
            ebitda[month] = null;
        }
    });

    return ebitda
}

// Do not have net_working_capital values on back end.
const netWorkingCapitalCalculation = (calcs, year, isForecast = false) => {
    // Current Assets - Current Liabilities (Still use current calcs)
    // Need to be careful if client only has data for specific months
    const netWorkingCapital = {}
    const getMonthlyVals = (metricKey) => {
        const metric = calcs?.[metricKey];
        if (!metric) return {};
        return isForecast
            ? _.pickBy(metric, _.isNumber) // forecast format
            : _.pickBy(metric?.[year], _.isNumber); // standard format
    };
    const totalCurrentAssets = getMonthlyVals('total_current_assets');
    const totalCurrentLiabilities = getMonthlyVals('total_current_liabilities');
    const allMonths = Object.keys(totalCurrentAssets).filter((month) => totalCurrentLiabilities.hasOwnProperty(month));

    allMonths.forEach((monthStr) => {
        const month = parseInt(monthStr);
        const assetVal = totalCurrentAssets[month];
        const liabilityVal = totalCurrentLiabilities[month];

        netWorkingCapital[month] =
            _.isNumber(assetVal) && _.isNumber(liabilityVal)
                ? assetVal - liabilityVal
                : null;
    });
    return netWorkingCapital // {1: 123, 2: 312, ...}
}

// The current net_working_capital_ratio values are wrong.
const netWorkingCapitalRatioCalculation = (calcs, year, isForecast = false) => {
    // Current Assets - Current Liabilities (Still use current calcs)
    // Need to be careful if client only has data for specific months
    const netWorkingCapitalRatio = {}
    const getMonthlyVals = (metricKey) => {
        const metric = calcs?.[metricKey];
        if (!metric) return {};
        return isForecast
            ? _.pickBy(metric, _.isNumber) // forecast format: flat { 1: val, 2: val }
            : _.pickBy(metric?.[year], _.isNumber); // standard format: { 2024: { 1: val, ... } }
    };
    const totalCurrentAssets = getMonthlyVals('total_current_assets');
    const totalCurrentLiabilities = getMonthlyVals('total_current_liabilities');
    const totalAssets = getMonthlyVals('total_assets');
    const allMonths = Object.keys(totalCurrentAssets).filter((month) => totalCurrentLiabilities.hasOwnProperty(month));

    allMonths.forEach((monthStr) => {
        const month = parseInt(monthStr);
        const assetVal = totalCurrentAssets[month];
        const liabilityVal = totalCurrentLiabilities[month];
        const totalAssetsVal = totalAssets[month]

        netWorkingCapitalRatio[month] =
            _.isNumber(assetVal) && _.isNumber(liabilityVal) && _.isNumber(totalAssetsVal)
                ? (assetVal - liabilityVal) / totalAssetsVal
                : null;
    });

    return netWorkingCapitalRatio // {1: 123, 2: 312, ...}
}

// trailing12MonthCalculations gets called when one of the keys we need to calculate the sum of the trailing 12 month values for
const trailing12MonthCalculations = (key, calcs, year, prevYear, isForecast = false, fallbackPrevYearData = null, forecastPreviousYearCalcs = null, forecastPage = false) => {
    let calculatedValues = {};
    // const isForecast = !year;

    switch (key) {
        case 'Return on Assets (ROA)':
        case 'Return on Equity (ROE)': ;
        case 'Return on Capital Employed (ROCE)':
        case 'Debt / Equity':
            calculatedValues = calcROAandROEandROCEandDE(key, calcs, year, prevYear, isForecast, fallbackPrevYearData, forecastPreviousYearCalcs, forecastPage);
            break;
        case 'Asset Turnover Ratio':
        case 'Accounts Receivable Days':
            calculatedValues = calcATRandARD(key, calcs, year, prevYear, isForecast, fallbackPrevYearData, forecastPreviousYearCalcs, forecastPage);
            break;
        case 'Inventory Turnover Ratio':
            calculatedValues = calcITR(calcs, year, prevYear, isForecast, fallbackPrevYearData, forecastPreviousYearCalcs, forecastPage);
            break;
        case 'Accounts Payable Days':
            calculatedValues = calcAPD(calcs, year, prevYear, isForecast, fallbackPrevYearData, forecastPreviousYearCalcs, forecastPage);
            break;
        case 'Senior Debt / EBITDA':
        case 'EBITDA / Annual Interest':
            calculatedValues = calcSDEandEAI(key, calcs, year, prevYear, isForecast, fallbackPrevYearData, forecastPreviousYearCalcs, forecastPage);
            break;
        case 'ROI':
            calculatedValues = calcROI(calcs, year, prevYear, isForecast, fallbackPrevYearData, forecastPreviousYearCalcs, forecastPage);
            break;
    }

    return calculatedValues;
}

const getSumForEachMonth = (i, monthNumber, previousYearMonth, numberOfPreviousYearMonths, numberOfEnoughMonths, metrics = {}, previousYearMetrics = {}) => {

    if (numberOfPreviousYearMonths > numberOfEnoughMonths) {
        let monthValues = {}

        // getting previous year month values
        for (let j = i + 1; j <= 12; j++) {
            if (previousYearMonth !== monthNumber) {
                monthValues[j] = previousYearMetrics[j]
            }
        }
        // getting current year month values
        for (let k = i + 1; k > 0; k--) {
            monthValues[k] = metrics[k]
        }

        let values = Object.values(monthValues)
        let sumForMonth = values.reduce((a, b) => {
            let firstVal = _.isNumber(a) ? a : 0;
            let secondVal = _.isNumber(b) ? b : 0;
            return (Number(firstVal.toFixed(2)) + Number(secondVal.toFixed(2)))
        })
        return sumForMonth
    }
}

const sumTrailing12MonthsValues = (value, calcs, year, prevYear, isForecast = false, fallbackPrevYearData = null, ytd = false, ytdMonths = [], forecastPreviousYearCalcs = null, forecastPage = false) => {
    // We need to get 12 values for trailing 12 months for each month client has data for.
    // Each month is going to need a sum, save each new sum value for each month in a new object.
    // Client may not always have data starting at January of current year and we need to be careful about getting values for the right months.
    let sumsOfTrailing12Months = {} // { 1: 0.1906043449119196, 2: 0.16704260377198493, 3: 0.31016848516398315, 4: 0.21613961614104255, 5: 0.11732514571381171}
    let metrics = {}
    let previousYearMetrics = {}

    // Lodash method _.pickBy takes the object as the 1st argument and a function as the 2nd argument to select properties that satisfy the function.
    // _.isNumber checks if the value is a number or not
    // Removing proprties with null values from given object to find out if we will have a total of 12 months to use from the current and previous years.
    // Ex. calcs: { roa:{ 1: 1231, 2: 23131, 3: 213, 4: 0, 5: null, 6: null, 7: ... 12: 0}}
    // Ex. previousYearCalcs: { roa:{ 1: 120, 2: 23000, 3: 213, 4: 0, 5: 3141, 6: 234234, 7: ... 12: 0}}
    if (forecastPage) {
        if (value === 'ebitda') {
            metrics = calcs?.[year]
            previousYearMetrics = calcs?.[prevYear]
        } else {
            metrics = _.pickBy(calcs?.[value], _.isNumber)
            previousYearMetrics = _.pickBy(forecastPreviousYearCalcs?.[value], _.isNumber)
        }
    } else {
        if (value === 'ebitda') {
            metrics = calcs?.[year]
            previousYearMetrics = calcs?.[prevYear]
        } else {
            metrics = _.pickBy(calcs?.[value]?.[year], _.isNumber)
            previousYearMetrics = isForecast ? _.pickBy(fallbackPrevYearData?.[value]?.[prevYear], _.isNumber) : _.pickBy(calcs?.[value]?.[prevYear], _.isNumber)
        }
    }

    // check the length of arrays
    let currentYearMonths = ytd ? ytdMonths : metrics ? Object.keys(metrics) : [] // ['1', '2', '3', '4', '5']
    let previousYearMonths = previousYearMetrics ? Object.keys(previousYearMetrics) : []// ['1', '2', '3', '4', '5', ...]
    let numberOfCurrentYearMonths = currentYearMonths.length
    let numberOfPreviousYearMonths = previousYearMonths.length
    // Check if we have less than 12 month values from both years and just return empty object which will show no values in table.
    if (numberOfCurrentYearMonths + numberOfPreviousYearMonths < 12) {
        return sumsOfTrailing12Months
    }
    // Getting a sums for each month per metrics/key.
    // Ex. if metrics/key is Return on Assets (ROA), current year is 2020 and previous year is 2019
    // when month = December 2020 (or Current Year), we can add all the values in the current calcs and don't need previousYearCalcs
    // November 2020, Nov -> Jan 2020 + December 2019: calcs.roa(1-11) previousYearCalcs.roa (12)
    // Oct 2020, Oct -> Jan 2020 + Dec -> Nov 2019: calcs.roa(1-10) previousYearCalcs.roa (11-12)
    // Sept 2020, Sept -> Jan 2020 + Dec -> Oct 2019: calcs.roa(1-9) previousYearCalcs.roa (10-12)
    // Aug 2020, Aug -> Jan 2020 + Dec -> Sept 2019: calcs.roa(1-8) previousYearCalcs.roa (9-12)
    // Jul 2020, Jul -> Jan 2020 + Dec -> Aug 2019: calcs.roa(1-7) previousYearCalcs.roa (8-12)
    // Jun 2020, Jun -> Jan 2020 + Dec -> Jul 2019: calcs.roa(1-6) previousYearCalcs.roa (7-12)
    // May 2020, May -> Jan 2020 + Dec -> Jun 2019: calcs.roa(1-5) previousYearCalcs.roa (6-12)
    // Apr 2020, Apr -> Jan 2020 + Dec -> May 2019: calcs.roa(1-4) previousYearCalcs.roa (5-12)
    // Mar 2020, Mar -> Jan 2020 + Dec -> Apr 2019: calcs.roa(1-3) previousYearCalcs.roa (4-12)
    // Feb 2020, Feb -> Jan 2020 + Dec -> Mar 2019: calcs.roa(1-2) previousYearCalcs.roa (3-12)
    // Jan 2020, Jan 2020 + Dec -> Feb 2019: calcs.roa(1) previousYearCalcs.roa (2-12)
    // january 2020
    // We're going through the number of months in the current year.
    // For each month we check the number and the number of months from the previous year to make we have 12 trailing months.
    // We create a new object and in the inner loop we set previous year months in that object.
    // After the loop we set current year months to this object based on which month we have current year data for.
    // Then the values for that object are set equal to an array. 
    // The array is reduced to get the sum for the month we need and pushed into the final sums array.

    for (let i = 0; i < numberOfCurrentYearMonths; i++) {
        let currentYearMonth = currentYearMonths[i].toString()
        let previousYearMonth = numberOfPreviousYearMonths && previousYearMonths[i] ? previousYearMonths[i].toString() : 0

        switch (currentYearMonth) {
            case '1':
                sumsOfTrailing12Months[1] = getSumForEachMonth(i, 1, previousYearMonth, numberOfPreviousYearMonths, 10, metrics, previousYearMetrics);
                break;
            case '2':
                sumsOfTrailing12Months[2] = getSumForEachMonth(i, 2, previousYearMonth, numberOfPreviousYearMonths, 9, metrics, previousYearMetrics);
                break;
            case '3':
                sumsOfTrailing12Months[3] = getSumForEachMonth(i, 3, previousYearMonth, numberOfPreviousYearMonths, 8, metrics, previousYearMetrics);
                break;
            case '4':
                sumsOfTrailing12Months[4] = getSumForEachMonth(i, 4, previousYearMonth, numberOfPreviousYearMonths, 7, metrics, previousYearMetrics);
                break;
            case '5':
                sumsOfTrailing12Months[5] = getSumForEachMonth(i, 5, previousYearMonth, numberOfPreviousYearMonths, 6, metrics, previousYearMetrics);
                break;
            case '6':
                sumsOfTrailing12Months[6] = getSumForEachMonth(i, 6, previousYearMonth, numberOfPreviousYearMonths, 5, metrics, previousYearMetrics);
                break;
            case '7':
                sumsOfTrailing12Months[7] = getSumForEachMonth(i, 7, previousYearMonth, numberOfPreviousYearMonths, 4, metrics, previousYearMetrics);
                break;
            case '8':
                sumsOfTrailing12Months[8] = getSumForEachMonth(i, 8, previousYearMonth, numberOfPreviousYearMonths, 3, metrics, previousYearMetrics);
                break;
            case '9':
                sumsOfTrailing12Months[9] = getSumForEachMonth(i, 9, previousYearMonth, numberOfPreviousYearMonths, 2, metrics, previousYearMetrics);
                break;
            case '10':
                sumsOfTrailing12Months[10] = getSumForEachMonth(i, 10, previousYearMonth, numberOfPreviousYearMonths, 1, metrics, previousYearMetrics);
                break;
            case '11':
                sumsOfTrailing12Months[11] = getSumForEachMonth(i, 11, previousYearMonth, numberOfPreviousYearMonths, 1, metrics, previousYearMetrics);
                break;
            case '12':
                sumsOfTrailing12Months[12] = getSumForEachMonth(i, 12, previousYearMonth, numberOfPreviousYearMonths, 0, metrics, previousYearMetrics);
                break;
        }
    }
    return sumsOfTrailing12Months;
}


const calcROI = (calcs, year, prevYear, isForecast = false, fallbackPrevYearData = null, forecastPreviousYearCalcs = null, forecastPage = false) => {
    const returnObject = {};
    if (calcs) {
        let sumTrailing12NetIncome = sumTrailing12MonthsValues('operating_expenses_net_income', calcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage);
        let capitalStock = forecastPage ? calcs?.capital_stock : calcs?.capital_stock?.[year];
        for (let month in sumTrailing12NetIncome) {
            if (capitalStock[month] !== 0) {
                // (last 12 months of operating_expenses_net_income) / capital stock
                returnObject[month] = sumTrailing12NetIncome[month] / capitalStock[month];
            }
        }
    }
    return returnObject;
}

// calculations for both return on assets and return on equity
// both use operating_expenses_net_income trailing 12 as a numerator
const calcROAandROEandROCEandDE = (key, calcs, year, prevYear, isForecast = false, fallbackPrevYearData = null, forecastPreviousYearCalcs = null, forecastPage = false) => {
    const returnObject = {};
    const currentYearTotalNetWorth = {};
    const denominatorROCE = {};
    const balanceSheetNetIncome = {};
    const sumTrailing12NetIncome = sumTrailing12MonthsValues('operating_expenses_net_income', calcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage) || {};
    const sumTrailing12OperatingProfit = sumTrailing12MonthsValues('operating_profit', calcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage) || {};
    const currentYearTotalAssets = forecastPage ? calcs?.total_assets : calcs?.total_assets?.[year];
    const currentYearLongTermDebt = forecastPage ? calcs?.long_term_debt : calcs?.long_term_debt?.[year];
    const currentTotalLiabilities = forecastPage ? calcs?.total_current_liabilities : calcs?.total_current_liabilities?.[year];
    const nonTrailing12NetIcome = forecastPage ? calcs?.operating_expenses_net_income : calcs?.operating_expenses_net_income?.[year];
    const capitalStockAll = forecastPage ? calcs?.capital_stock : calcs?.capital_stock?.[year];
    const ownerDistributionsAll = forecastPage ? calcs?.owner_distributions : calcs?.owner_distributions?.[year];
    const retainedEarningsAll = forecastPage ? calcs?.retained_earnings : calcs?.retained_earnings?.[year];

    const nonTrailing12NetIcomeValues = Object.values(nonTrailing12NetIcome || {});
    let helperTotal = 0;
    nonTrailing12NetIcomeValues.forEach((value, index) => {
        if (typeof value === 'number') {
            helperTotal += value;
            balanceSheetNetIncome[index + 1] = helperTotal;
        }
    });

    for (let month in sumTrailing12NetIncome) {
        const capitalStock = capitalStockAll?.[month] ?? 0;
        const ownerDistributions = ownerDistributionsAll?.[month] ?? 0;
        const retainedEarnings = retainedEarningsAll?.[month] ?? 0;
        const longTermDebt = currentYearLongTermDebt?.[month] ?? 0;
        const totalAssets = currentYearTotalAssets?.[month] ?? null;
        const totalLiabilities = currentTotalLiabilities?.[month] ?? 0;
        const netIncome = sumTrailing12NetIncome?.[month] ?? null;
        const operatingProfit = sumTrailing12OperatingProfit?.[month] ?? null;

        currentYearTotalNetWorth[month] = capitalStock + ownerDistributions + retainedEarnings + (balanceSheetNetIncome?.[month] ?? 0);
        denominatorROCE[month] = longTermDebt + currentYearTotalNetWorth[month];

        if (key === 'Return on Assets (ROA)' && totalAssets !== 0 && netIncome !== null) {
            returnObject[month] = netIncome / totalAssets;
        } else if (key === 'Return on Equity (ROE)' && currentYearTotalNetWorth[month] !== 0 && netIncome !== null) {
            returnObject[month] = netIncome / currentYearTotalNetWorth[month];
        } else if (key === 'Return on Capital Employed (ROCE)' && denominatorROCE[month] !== 0 && operatingProfit !== null) {
            returnObject[month] = operatingProfit / denominatorROCE[month];
        } else if (key === 'Debt / Equity' && currentYearTotalNetWorth[month] !== 0) {
            returnObject[month] = (totalLiabilities + longTermDebt) / currentYearTotalNetWorth[month];
        } else {
            returnObject[month] = null;
        }
    }

    return returnObject;
}

// calculations for both Asset Turnover Ratio and Accounts Receivable Days
// both use trailing 12 total revenue
const calcATRandARD = (key, calcs, year, prevYear, isForecast = false, fallbackPrevYearData = null, forecastPreviousYearCalcs = null, forecastPage = false) => {
    const returnObject = {};
    if (calcs) {
        let sumTrailing12TotalRevenue = sumTrailing12MonthsValues('total_revenue', calcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage);
        let currentYearTotalAssets = forecastPage ? calcs?.total_assets : calcs?.total_assets?.[year];
        let currentYearAcctsRec = forecastPage ? calcs?.accounts_receivable : calcs?.accounts_receivable?.[year];
        // month example looks like '1', '2', '3', ...
        for (let month in sumTrailing12TotalRevenue) {
            if (key === 'Asset Turnover Ratio' && currentYearTotalAssets[month] !== 0) {
                // (last 12 months of total_revenue) / total_assets
                returnObject[month] = sumTrailing12TotalRevenue[month] / currentYearTotalAssets[month];
            } else if (key === 'Accounts Receivable Days' && sumTrailing12TotalRevenue[month] !== 0) {
                // ( 360 * accounts_receivable ) / (last 12 months of total_revenue)
                returnObject[month] = (360 * currentYearAcctsRec[month]) / sumTrailing12TotalRevenue[month];
            }
        }
        return returnObject;
    }
    return returnObject;
}

// Inventory Turnover Ratio
const calcITR = (calcs, year, prevYear, isForecast = false, fallbackPrevYearData = null, forecastPreviousYearCalcs = null, forecastPage = false) => {
    const returnObject = {};
    const denominator = {};
    if (calcs) {
        let sumTrailing12COGSMat = sumTrailing12MonthsValues('materials_costs', calcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage);
        let currentYearInventory = forecastPage ? calcs?.inventory : calcs?.inventory?.[year];
        let previousYearInventory = forecastPage ? forecastPreviousYearCalcs?.inventory : isForecast ? fallbackPrevYearData?.inventory?.[prevYear] : calcs?.inventory?.[prevYear];

        for (let month in sumTrailing12COGSMat) {
            denominator[month] = (currentYearInventory[month] + previousYearInventory[month]) / 2;
            if (denominator[month] !== 0) {
                returnObject[month] = sumTrailing12COGSMat[month] / denominator[month];
            } else {
                returnObject[month] = 0;
            }
        }
        return returnObject
    }
    return returnObject
}

// Accounts Payable Days
const calcAPD = (calcs, year, prevYear, isForecast = false, fallbackPrevYearData = null, forecastPreviousYearCalcs = null, forecastPage = false) => {
    const returnObject = {};
    const denominator = {};
    if (calcs) {
        let sumCOGS = sumTrailing12MonthsValues('total_costs', calcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage);
        let sumLaborCosts = sumTrailing12MonthsValues('labor_costs', calcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage);
        let sumTotalOpEx = sumTrailing12MonthsValues('total_operating_expenses', calcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage);
        let sumTotalTaxBenies = sumTrailing12MonthsValues('total_taxes_and_benefits', calcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage);
        let sumTotalComp = sumTrailing12MonthsValues('total_compensation', calcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage);
        let currentYearAccountsPayable = forecastPage ? calcs?.accounts_payable : calcs?.accounts_payable?.[year];

        for (let month in sumCOGS) {
            denominator[month] = sumCOGS[month] - sumLaborCosts[month] + sumTotalOpEx[month] - sumTotalTaxBenies[month] - sumTotalComp[month];
            if (denominator[month] !== 0) {
                returnObject[month] = (360 * currentYearAccountsPayable[month]) / denominator[month];
            }
        }
        return returnObject
    }
    return returnObject
}

// calculations for both Senior Debt / EBITDA and EBITDA / Annual Interest
// both use trailing 12 months of EBITDA
const calcSDEandEAI = (key, calcs, year, prevYear, isForecast = false, fallbackPrevYearData = null, forecastPreviousYearCalcs = null, forecastPage = false) => {
    const returnObject = {};
    if (calcs) {
        let ebitdaCalcs = {}
        let sumTrailing12Interest = sumTrailing12MonthsValues('interest_and_other_expenses', calcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage)
        if (forecastPage) {
            year = 'year1'
            prevYear = 'year2'
        }
        ebitdaCalcs[year] = forecastPage ? calculateEBITDA(calcs, null, true) : calculateEBITDA(calcs, year)
        ebitdaCalcs[prevYear] = forecastPage ? calculateEBITDA(forecastPreviousYearCalcs, null, true) : isForecast ? calculateEBITDA(fallbackPrevYearData, prevYear) : calculateEBITDA(calcs, prevYear)
        let sumTrailing12EBITDA = sumTrailing12MonthsValues('ebitda', ebitdaCalcs, year, prevYear, isForecast, fallbackPrevYearData, false, [], forecastPreviousYearCalcs, forecastPage);
        let currentYearLOC = forecastPage ? calcs?.line_of_credit : calcs?.line_of_credit?.[year];
        let currentYearCurrentPortionLTD = forecastPage ? calcs?.current_portion_of_ltd : calcs?.current_portion_of_ltd?.[year];
        let currentYearLTD = forecastPage ? calcs?.long_term_debt : calcs?.long_term_debt?.[year];

        // month example looks like '1', '2', '3', ...
        for (let month in sumTrailing12EBITDA) {
            if (key === 'Senior Debt / EBITDA' && sumTrailing12EBITDA[month] !== 0) {
                // (long_term_debt + line_of_credit + current_portion_of_ltd) / (last 12 months of ebitda)
                returnObject[month] = (currentYearLOC[month] + currentYearCurrentPortionLTD[month] + currentYearLTD[month]) / sumTrailing12EBITDA[month];
            } else if (key === 'EBITDA / Annual Interest' && sumTrailing12Interest[month] !== 0) {
                // (last 12 months of ebitda) / (last 12 months of interest_and_other_expenses)
                returnObject[month] = sumTrailing12EBITDA[month] / sumTrailing12Interest[month];
            }
        }
        return returnObject;
    }
    return returnObject;
}

export { ratioCalculations, ratioCalculationsMoney, calculateEBITDA, netWorkingCapitalCalculation, netWorkingCapitalRatioCalculation, trailing12MonthCalculations, sumTrailing12MonthsValues };